// Esta es la URL original que se sustituye por la base de abajo
// para evitar problemas de CORS.
export const UNPROXIED_BASE_URL = 'https://weeqp.azurewebsites.net/GS/Broker/';
export const BASE_URL = process.env.REACT_APP_URL_API;

// FORM 1 ENDPOINTS
export const FORM1_SUBMIT_URL = `${BASE_URL}API/api/Amae/AddTramiteAndAge`;

// FORM 2 ENDPOINTS
export const FORM2_SUBMIT_URL = `${BASE_URL}API/api/Amae/UpdateDataByTramite`;

// FORM 3 ENDPOINTS
export const FORM3_GET_AMOUNT_URL = `${BASE_URL}API/api/Amae/UpdateDataCotizacionByTramite`;

// FORM 4 ENDPOINTS
export const FORM4_SUBMIT_URL = `${BASE_URL}API/api/Amae/Transaccion_weeame_V_1`;
export const OP_KEYS_URL = `${BASE_URL}API/api/Amae/ValidaSesionTransaccion`;

// FORM 5 ENDPOINTS
export const FORM5_SUBMIT_URL = `${BASE_URL}API/api/Amae/UpdateDataRegistroDireccion`;
export const FORM5_BLACKLIST_CHECK = `${BASE_URL}API/api/WeeBroker/Cobertura_VerifyListBlack`;

// FORM 6 ENDPOINTS
export const FORM6_SUBMIT_URL = `${BASE_URL}Api/api/Amae/UpdateDatosFiscalesByTramitebroker`;
export const GET_INVOICE_DATA = `${BASE_URL}API/api/Amae/GetDataTimbrado`;

// GENERAL ENDPOINTS
export const GET_TERMS_DOCUMENTS_URL = `${BASE_URL}API/api/Amae/getAvisoDePrivacidad`;
export const REGISTER_PASOS_URL = `${BASE_URL}API/api/Amae/RegistroPasos_UpdateRegistroPasos`;
export const GET_RFC_CURP_URL = `${BASE_URL}API/api/Utilidades/ConsultaRFCWee`;
export const GET_CP_DATA_URL = `${BASE_URL}API/api/Ubicacion/GetDatosCPWee`;
export const VALIDATE_EMAIL_URL = `${BASE_URL}API/api/Amae/getValidarCorreoCredenciales`;
export const EMMIT_INSURANCE_POLICY_URL = `${BASE_URL}API/api/WeeBroker/Emision_GetPolizaFolioPago`;
export const EMMIT_INVOICE_URL = `${BASE_URL}API/api/Amae/AddFacturacionAmae`;
export const STAMP_INVOICE_URL = `${BASE_URL}API/api/WeeBroker/TimbrarFactura`;
export const GENERATE_INVOICE_FILES_URL = `${BASE_URL}api/PDF/Facturacion/viewFacturaAmae.aspx?facturaid=`;
export const SEND_INVOICE_BY_EMAIL_URL = `${BASE_URL}API/api/Amae/SendEmail_DatosFacturacionAmae`;
export const SEND_WELCOME_EMAIL_URL = `${BASE_URL}API/api/Amae/SendEmail_DatosBienvenida`;
export const GENERATE_POLICY_COVER_URL = `${BASE_URL}API/PDF/PDFAmae/CaratulaPolizaAmae.aspx?idPoliza=`;
export const REQUEST_DIABETES_FILE_URL = `${BASE_URL}API/PDF/PDFAmae/SolicitudDiabetesAmae.aspx?idPoliza=`;
export const SEND_AFFILIATE_CREDENTIALS_URL = `${BASE_URL}API/api/DerechoHabiente/ReenviarCredencialesAfiliadoBroker`;
export const PAYMENT_COMPLEMENT_STAMP = `${BASE_URL}API/api/Amae/GenerarComplementoPago`;
export const GENERATE_PAYMENT_COMPLEMENT_FILE = `${BASE_URL}api/PDF/Facturacion/viewFacturaComplementoAmae.aspx?idFactura=`;
export const CONFIRM_FISCAL_DATA_URL = `${BASE_URL}Api/api/Amae/UpdateDatosFiscalesByTramitebroker`;
export const SUBMIT_INSURED_PERSON_DATA_URL = `${BASE_URL}API/api/Amae/addupdateDataContratante`;
export const GET_STATE_LIST = `${BASE_URL}API/api/DerechoHabiente/GetEstado`;
export const GET_TAX_REGIME_LIST = `${BASE_URL}Api/api/Utilidades/Catalogo_RegimeFiscal`;
export const GET_MARITAL_STATUS_LIST = `${BASE_URL}API/api/Amae/getEstadoCivil`;

// LOGGING API
export const LOGGING_API_BASE_URL = process.env.REACT_APP_URL_API;
export const LOGGING_API_REGISTER_STEP = `${LOGGING_API_BASE_URL}api/v1/gpv/public/register-step/`;

// OTHERS
export const EXIT_URL = process.env.REACT_APP_EXIT_URL;
export const APP_DOWNLOAD_URL = `${UNPROXIED_BASE_URL}/Descarga`;
